export default {
    inject: ['clienteContainer'],
    computed: {
        cliente () {
            return this.clienteContainer.cliente
        }
    }
}
